<mat-card>
  <app-card-header
    title="Detalle del permiso"
    [subtitle]="
      nombrePersona ? nombreUsuario + ' · ' + nombrePersona : nombreUsuario
    "
    icono="security"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Cliente / Nivel / Alcance -->
    <app-content-card title="Alcance" icon="account_tree">
      <div class="datos-grid">
        <div class="dato">
          <span class="dato-etiqueta">Cliente</span>
          <span class="dato-valor" [matTooltip]="tooltipJerarquia">
            @if (permiso.cliente?.nombre || permiso.idCliente) {
              {{ permiso.cliente?.nombre || permiso.idCliente }}
            } @else {
              <span class="no-info">Sin información</span>
            }
          </span>
        </div>

        @if (alcance) {
          <div class="dato">
            <span class="dato-etiqueta">Nivel</span>
            <span class="dato-valor">
              {{ alcance.nivel }}
              @if (alcance.nivel === 'Cliente' && alcance.includeChildren) {
                <span class="chip">
                  <mat-icon>subdirectory_arrow_right</mat-icon>
                  Incluye dependientes
                </span>
              }
            </span>
          </div>

          <!-- Alcance: de qué entidades/grupos es el permiso -->
          @if (alcance.nivel !== 'Cliente') {
            <div class="dato dato-ancho">
              <span class="dato-etiqueta">{{ alcance.label }}</span>
              <div class="chips">
                @for (nombre of alcance.nombres; track nombre) {
                  <span class="chip">{{ nombre }}</span>
                }
                @if (alcance.sinResolver) {
                  <span class="chip chip-warn">
                    {{ alcance.sinResolver }} sin resolver
                  </span>
                }
                @if (!alcance.nombres.length && !alcance.sinResolver) {
                  <span class="no-info">Sin asignar</span>
                }
              </div>
            </div>
          }
        }
      </div>
    </app-content-card>

    <!-- Vigencia y estado -->
    <app-content-card title="Vigencia" icon="date_range">
      <div class="datos-grid">
        <div class="dato">
          <span class="dato-etiqueta">Creado</span>
          <span class="dato-valor">
            @if (permiso.fechaCreacion) {
              {{ permiso.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              <span class="no-info">Sin información</span>
            }
          </span>
        </div>

        <div class="dato">
          <span class="dato-etiqueta">
            @if (permiso.vencimiento?.fechaVencimiento) {
              Vencimiento
            } @else {
              Vigencia
            }
          </span>
          <span class="dato-valor">
            @if (permiso.vencimiento?.fechaVencimiento) {
              {{ permiso.vencimiento?.fechaVencimiento | date: 'dd/MM/yyyy' }}
            } @else {
              Permanente
            }
          </span>
        </div>

        <div class="dato">
          <span class="dato-etiqueta">Estado</span>
          <span
            class="dato-valor estado"
            [class.ok]="permiso.activo"
            [class.inactivo]="!permiso.activo"
          >
            <mat-icon>
              {{ permiso.activo ? 'check_circle' : 'cancel' }}
            </mat-icon>
            {{ permiso.activo ? 'Activo' : 'Inactivo' }}
          </span>
        </div>

        @if (
          permiso.modulos?.moduloAlertasSeguridad &&
          (permiso.tieneCredencialesSeguridad ||
            permiso.credencialesSeguridad?.usuario)
        ) {
          <div class="dato">
            <span class="dato-etiqueta">Credenciales de seguridad</span>
            <span class="dato-valor">
              {{ permiso.credencialesSeguridad?.usuario || 'Configuradas' }}
            </span>
          </div>
        }
      </div>
    </app-content-card>

    <!-- Roles -->
    <app-content-card title="Roles" icon="badge">
      <div class="seccion-cuerpo">
        @if (permiso.rols?.length) {
          <div class="chips">
            @for (rol of permiso.rols; track rol._id) {
              <span class="chip">{{ rol.nombre }}</span>
            }
          </div>
        } @else {
          <span class="no-info">Sin roles asignados</span>
        }
      </div>
    </app-content-card>

    <!-- Módulos -->
    <app-content-card title="Módulos habilitados" icon="widgets">
      <div class="seccion-cuerpo">
        @if (modulos.length) {
          <div class="modulos-grid">
            @for (modulo of modulos; track modulo.nombre) {
              <div class="modulo-chip">
                <mat-icon class="modulo-icon">{{ modulo.icon }}</mat-icon>
                <span>{{ modulo.nombre }}</span>
              </div>
            }
          </div>
        } @else {
          <span class="no-info">Sin módulos habilitados</span>
        }
      </div>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="verAccionesEfectivas()"
    >
      <mat-icon>rule</mat-icon>
      Ver acciones efectivas
    </button>
    <button irxBoton="principal" type="button" (click)="cerrar()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
